<button #button
        mat-icon-button
        type="button"
        [attr.aria-haspopup]="picker ? 'dialog' : null"
        [attr.aria-label]="ariaLabel"
        [attr.tabindex]="disabled ? -1 : tabIndex"
        [disabled]="disabled"
        [disableRipple]="disableRipple">

  <svg *ngIf="!_customIcon"
       class="mtx-colorpicker-toggle-default-icon"
       viewBox="0 0 24 24"
       width="24px"
       height="24px"
       fill="currentColor"
       focusable="false">
    <path
          d="M17.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,9A1.5,1.5 0 0,1 19,10.5A1.5,1.5 0 0,1 17.5,12M14.5,8A1.5,1.5 0 0,1 13,6.5A1.5,1.5 0 0,1 14.5,5A1.5,1.5 0 0,1 16,6.5A1.5,1.5 0 0,1 14.5,8M9.5,8A1.5,1.5 0 0,1 8,6.5A1.5,1.5 0 0,1 9.5,5A1.5,1.5 0 0,1 11,6.5A1.5,1.5 0 0,1 9.5,8M6.5,12A1.5,1.5 0 0,1 5,10.5A1.5,1.5 0 0,1 6.5,9A1.5,1.5 0 0,1 8,10.5A1.5,1.5 0 0,1 6.5,12M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A1.5,1.5 0 0,0 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5A1.5,1.5 0 0,1 14.23,16H16A5,5 0 0,0 21,11C21,6.58 16.97,3 12,3Z" />
  </svg>

  <ng-content select="[mtxColorpickerToggleIcon]"></ng-content>
</button>
